import type { RouteRecordRaw } from 'vue-router'

const settingsRoutes: RouteRecordRaw[] = [
  {
    path: 'settings/diagnostic',
    name: 'SettingsDiagnostic',
    component: () => import('@/pages/settings/DiagnosticUpload.vue'),
    meta: { title: '诊断日志上传', requiresAuth: true },
  },
]

export default settingsRoutes
